export function lightenColor(hex, percent) {
  hex = hex?.replace("#", "") || "F49102"

  // Convert hex to RGB values
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // Increase brightness by percentage
  // const factor = 1 + percent / 100
  // const newR = Math.min(Math.round(r * factor), 255)
  // const newG = Math.min(Math.round(g * factor), 255)
  // const newB = Math.min(Math.round(b * factor), 255)

  // // Convert new RGB values to hex code
  // const newHex = ((newR << 16) | (newG << 8) | newB).toString(16)
  // return "#" + newHex.padStart(6, "0")

  return `rgb(${r}, ${g}, ${b}, ${percent / 100})`
}
